export default __webpack_public_path__ + "static/media/UNICRI Logo.89fe63ae.png";